<template>
  <div class="card assets-detail">
    <header class="card-header has-background-dark">
      <p class="card-header-title has-text-light">ASSET {{ asset.thirdPartyCode }}</p>
      <div class="buttons has-addons">
        <button :class="`button is-small ${asset.hotspot ? 'is-warning is-active' : ''} ${toggling ? 'is-loading' : ''}`" @click="toggleHotspot">HOTSPOT</button>
      </div>
    </header>
    <div class="card-content">
      <table class="table is-fullwidth is-bordered is-narrowed" style="margin:0">
        <tbody>
          <tr>
            <th>CODE</th>
            <td>{{ asset.code ? asset.code.code : "N/A" }}</td>
          </tr>
          <tr>
            <th>TYPE</th>
            <td>{{ asset.code ? asset.code.name : "N/A" }}</td>
          </tr>
          <tr>
            <th colspan="2">ATTRIBUTES</th>
          </tr>
        </tbody>
      </table>
      <div id="asset_attributes">
        <table class="table is-fullwidth is-bordered is-narrowed is-striped">
          <tbody>
            <tr v-for="tag in tags" :key="tag.key">
              <th>{{ tag.key }}</th>
              <td>{{ tag.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { AssetService } from "@/services/asset.service.js";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";

export default {
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    toggling: false
  }),
  computed: {
    tags() {
      if (this.asset.tags) {
        const tags = JSON.parse(this.asset.tags);

        return Object.keys(tags).map(key => {
          return {
            key: key,
            value: tags[key]
          };
        });
      }

      return [];
    }
  },
  methods: {
    toggleHotspot() {
      this.toggling = true;

      AssetService.toggleHotspot(this.asset.id).then(
        response => {
          const asset = JsonDenormalizer.denormalize(response);
          this.$emit("update:hotspot", asset.hotspot);
          this.toggling = false;
        },
        error => {
          this.toggling = false;
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
#asset_attributes {
  height: 100%;
  padding: 0;
  overflow-y: scroll;
}
.card-header {
  .buttons {
    padding-right: 0.75em;
    margin-bottom: -0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Assets/list/partials/detail.vue